import { defineStore } from 'pinia'
import PartnerService from "@/services/partner.service";
export const usePartnerStore = defineStore('partner', {
    state: () => {
        return {
            partners: [],
            invitePartner: [],
            paginate: {},
        }
    },
    persist: true,
    actions: {
        async getListPartnerWithLimit(url, params) {
            try {
                const res = await PartnerService.getListPartners(url, params)
                this.partners = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return null
            }
        },

        async getListInviteFromPartner(url, params) {
            try {
                const res = await PartnerService.getListInviteFromPartner(url, params)
                this.invitePartner = res.data.data
                this.paginate = res.data.meta
            } catch (e) {
                return null
            }
        },
        async getListPartners(url, params) {
            try {
                const res = await PartnerService.getListPartners(url, params)
                this.partners = res.data
            } catch (e) {
                return null
            }
        },
        async createPartner(url, params) {
            try {
                const res = await PartnerService.createPartner(url, params)
                return res.data;
            } catch (e) {
                return e
            }
        },
        async confirmCooperate(url, params) {
            try {
                const res = await PartnerService.confirmCooperate(url, params)
                return res.data;
            } catch (e) {
                return e
            }
        },
        async delete(url, params) {
            try {
                const res = await PartnerService.deletePartner(url, params)
                return res.data
            } catch (e) {
                return e
            }
        },
        async acceptInvite(url, params) {
            try {
                const res = await PartnerService.acceptInvite(url, params)
                return res.data
            } catch (e) {
                return e
            }
        }
    }
})
